// import useSettings from "app/hooks/useSettings";
import { Box } from "@mui/material";

export default function MatxLogo({ mode }) {
  // const { settings } = useSettings();
  // const theme = settings.themes[settings.activeTheme];

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      padding='auto'
      margin='auto'
      sx={{ 
        backgroundColor : 'white', 
        borderRadius : '25%',
        width: mode === "compact" ? "auto" : 100,
      }}
    >
      <img
        style={{
          maxWidth: "100%",
          display: "block",
        }}
        alt="Income Tax Library Logo"
        src="/static/assets/images/logo.png"
      />
    </Box>
  );
}
